import { useState, useEffect } from 'react';
import { ObjectI, QueryI } from '../../../libs/interfaces';

interface DataPropsI{
  value: null | string;
  id: null | number;
}

export const useAutocomplete = (
  clientesQuery:QueryI, 
  data?:DataPropsI,
  ) => {
    
    const [ forms, setForms ] = useState({
        value:'',
        id:0,
      });

    useEffect(()=>{
      if(data){
        setForms({value:data?.value!, id:data?.id!})
      }
    },[])

 

    const handleFormsAutocomplete = (event: any, newValue: string | null)=>{ 
        let id:number =0;

        if(newValue)
          id = clientesQuery.data.data.find((el:ObjectI)=>el.name === newValue)!.id;
        
        setForms({...forms, 
            value:newValue ?? "",
            id:id,
        })
    }

  
  return {
    value:forms.value,
    id:forms.id,
    handleFormsAutocomplete
  }
}
